import React from 'react';
import PropTypes from 'prop-types';
// common components
import SelectionControl from './../../../common/Forms/SelectionControl/SelectionControl';

const ManageParticipant = ({title, userList, onToogleCheck, batchPartList}) => {
	if(userList && userList.length > 0 && title === 'add')  {
		return(
            <div className='ManageParticipant'>
				{userList.map(item => {
					if(!(batchPartList.some(part => part.user_id === item.id))) {
						return (
							<div key={item.id}>
								<SelectionControl
									checkbox
									label={`${item.firstname} ${item.lastname}`}
									value={JSON.stringify(item.id)}
									onToogleCheck={(val)=> onToogleCheck(item.id, val)}
								/>
							</div>
						)
					}
					return null;
				})}
            </div>
        );
	}
	if(batchPartList && batchPartList.length > 0 && title === 'delete')  {
		return (
			<div className='ManageParticipant'>
				{batchPartList.map(item => (
					<div key={item.id}>
						<SelectionControl
							checkbox
							label={item.user_name}
							value={JSON.stringify(item.id)}
							onToogleCheck={(val)=> onToogleCheck(item.user_id, val)}
						/>
					</div>
				))}
			</div>
		);
	}
	return null;
}

ManageParticipant.propTypes = {
	title: PropTypes.string,
	userList: PropTypes.instanceOf(Array),
	onToogleCheck: PropTypes.func,
	batchPartList: PropTypes.instanceOf(Array)
};

ManageParticipant.defaultProps = {
	title: '',
	userList: {},
	onToogleCheck: () => {},
	batchPartList: {}
};

export default ManageParticipant;



// WEBPACK FOOTER //
// ./components/BatchParticipant/ManageParticipant/ManageParticipant.js